import { FiBook, FiCalendar } from 'react-icons/fi';
import { formatDaysList } from '../../types/student';

export default function StudentCourses({ courses }) {
  return (
    <div className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden">
      <div className="px-6 py-5 border-b border-gray-200 dark:border-gray-700">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white">
          Enrolled Courses
        </h3>
      </div>
      <div className="px-6 py-5">
        <div className="space-y-4">
          {courses.map((course, index) => (
            <div 
              key={index}
              className="flex items-start space-x-4 p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg"
            >
              <div className="flex-shrink-0">
                <div className="p-2 bg-primary-50 dark:bg-primary-900/30 rounded-lg">
                  <FiBook className="h-5 w-5 text-primary dark:text-primary-400" />
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 dark:text-white">
                  {course.name}
                </p>
                <div className="mt-2 flex items-center text-sm text-gray-500 dark:text-gray-400">
                  <FiCalendar className="flex-shrink-0 mr-1.5 h-4 w-4" />
                  {formatDaysList(course.days)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}